(function () {
  "use strict";

  /**
   * @memberof app
   * @ngdoc controller
   * @name ActivosController
   * @description
   * This is main controller
   **/

  angular.module("app").controller("ActivosController", ActivosController);
  ActivosController.$inject = [
    "ActivosService",
    "GeneralService",
    "$timeout",
    "$scope",
    "$window",
    "$interval",
    "CookiesService",
  ];

  function ActivosController(
    ActivosService,
    GeneralService,
    $timeout,
    $scope,
    $window,
    $interval,
    CookiesService
  ) {
    var vm = this;
    vm.activos = [];
     vm.adjuntosData = null;
    vm.today = new Date();
    vm.startDate = null;
    vm.endDate = null;
    vm.filtros = {};
    vm.filtros.page = 0;
    vm.error = false;
    vm.loading = false;
    vm.filtrando = false;
    vm.generalService = GeneralService;
    vm.Message = {};
    vm.texto = "";
    vm.mensajes = [];

    vm.map = {
      id: 1,
      center: {
        latitude: 40.4168,
        longitude: -3.7038,
      },
      zoom: 16,
      refresh: false,
      events: {},
      bounds: {},
      draw: undefined,
    };

    $scope.isValid = function (value) {
      // Verificar si el valor es un número, una cadena válida o cualquier otro criterio de validación
      let valido = (
        value !== undefined &&
        value !== null &&
        (typeof value === "string" ||
          typeof value === "number" ||
          (Array.isArray(value) && value.length > 0))
      );
      if(!valido)
        vm.filtros.municipio_id = "0"

      return valido
    };

    vm.checkStreetView = function (lat, lng, activo_id) {
      ActivosService.checkStreetView(lat, lng, activo_id).then(function (data) {
         console.log(data);
        vm.existMap = data;
      });
    };

    vm.setMarker = function () {
      vm.map.marker = _.extend({}, vm.map.center);
    };

    vm.getActivosActive = false;
    vm.getActivos = function (noreset) {
      if (!vm.getActivosActive) return false;

      vm.filtrando = true;

      if (!noreset) {
        vm.activos = [];
        vm.filtros.page = 0;
        $scope.$broadcast("getActivos", noreset);
      }

      CookiesService.saveCookie(
        "activosFiltros",
        JSON.stringify(vm.filtros),
        8
      );
      CookiesService.saveCookie("startDate", vm.startDate);
      CookiesService.saveCookie("endDate", vm.endDate);

      ActivosService.FiltrosActivos(vm, vm.startDate, vm.endDate).then(
        function (data) {
          vm.activos = vm.activos.concat(data.activos);
          vm.itemsTiposActivos = data.itemsTiposActivos;
          vm.filtrando = false;
          vm.loading = true;
          vm.maxPages = data.maxPages - 1;
          if (vm.activos.length === 0) {
            vm.error = true;
          }
        }
      );

      vm.error = false;
      vm.loading = false;
    };

    vm.initFiltros = function () {
      var filtrosGuardados = CookiesService.getCookie("activosFiltros");

      const startDateGuardada = CookiesService.getCookie("startDate");
      const endDateGuardada = CookiesService.getCookie("endDate");

      if (filtrosGuardados) {
        vm.filtros = JSON.parse(filtrosGuardados);
      } else {
        vm.filtros.serv_origen = "0";
        vm.filtros.cod_serv = "0";
        vm.filtros.uso_id = "0";
        vm.filtros.municipio_id = "0";
        vm.filtros.orden = "0";
      }

      if (startDateGuardada && endDateGuardada) {
        vm.startDate = startDateGuardada;
        vm.endDate = endDateGuardada;
      }
      $timeout(function () {
        vm.getActivosActive = true;
        vm.getActivos(false);
      }, 1000);
    };

    vm.activoseleccionado = function (activo_id) {
      ActivosService.Activofav(activo_id).then(function (data) {
        vm.activo = data.activo;
        vm.activo_id = activo_id;
        vm.result = data.result;
      });
    };

    vm.activoExport = (activoId) => {
      return ActivosService.ActivoExport(activoId).then((data) => {
        if (data.status == "success") {
          $window.location.href = data.url;
          return;
        }
        if (data.status == 500) {
          return;
        }
      });
    };

    // ====================== Solicitudes ======================

      vm.mensajesInit = function() {

	  if(vm.adjuntosData != undefined && vm.adjuntosData.length != 0  ){
	      

	      vm.adjuntosData = JSON.parse(vm.adjuntosData);
	  }


  };
	  
      
    vm.getSolicitudes = () => {
      return ActivosService.Solicitudes(vm.Message).then((data) => {
        vm.mensajes = data.formulario_historial;

        vm.mensajes.forEach(function (mensaje) {
          mensaje.created = new Date(mensaje.created.replace(" ", "T"));
        });
        return vm.mensajes;
      });
    };

    vm.initMensajesInterval = function (ms) {
      vm.getSolicitudes().then(() => {
        $interval(vm.getSolicitudes, ms);
      });
    };

      vm.solicitudMensaje = function () {
	  console.log("asasa")
      vm.Message.mensaje = vm.texto;
      vm.Message.subject = "user answer";
//      vm.Message.email = "ivan@alt120.com";
      return ActivosService.SolicitudMensaje(vm.Message).then((data) => {
        vm.getSolicitudes();
        return vm.mensajes;
      });
    };

    vm.alternarDescartada = (data) => {
      return ActivosService.AlternarDescartada(data).then((response) => {
        $window.location.href = $window.location.href;
        return response;
      });
    };

    // =============================================

    vm.getCategorias = function () {
      ActivosService.Categories().then(function (data) {
        vm.categoria_activos = data.categoria_activos;
        // vm.municipios = data.municipios;
        // vm.provincias = data.provincias;
        vm.tipo_activos = data.tipo_activos;
        vm.usos = data.usos;
      });
    };

    vm.removeFilters = function () {
      vm.filtros = {
        // provincia_id: '0',
        municipio_id: "0",
        serv_origen: "0",
        cod_serv: "0",
        ref_cat_id: "",
        cod_cert: "",
        uso_id: "0",
        cat_categoria_activo_id: {},
        // cat_tipo_activo_id:'0',
        destacado: false,
        orden: "0",
      };
      vm.dateRange = "Seleccionar";
      vm.startDate = "";
      vm.endDate = "";
      $scope.$broadcast("cleaninputdates");
    };

    $scope.$on("datepickerCreate", function (event, data) {
      // vm.startDate = data.startDate.format("DD/MM/YYYY");
      // vm.endDate = data.endDate.format("DD/MM/YYYY");
    });

    $scope.$on("dateRangeChanged", function (event, data) {
      vm.startDate = data.startDate;
      vm.endDate = data.endDate;

      $scope.$apply();
      vm.getActivos();
    });
  }
})();
